import { useEffect, useRef } from "react";
import Lenis from "lenis";

export function useLenis() {
  const ref = useRef(null);
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    ref.current = lenis;
    let frame;
    const raf = (t) => {
      lenis.raf(t);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);
  return ref;
}
